import routeArray from '../components/front/header/menu';

export function breadcrumb(props) {

    let category = props.location.pathname.split('/')[1];
    let subCategory = props.location.pathname.split('/')[2];
    if (props.location.pathname.indexOf('/details') > -1) {
        category = props.location.pathname.split('/')[2];
        subCategory = props.location.pathname.split('/')[3];
    }
    //console.log(category + " : " + subCategory);

    let title;
    let path;
    let categoryName;
    let subCategoryName;

    for (var i = 0; i < routeArray.length; i++) {
        if (routeArray[i].children) {
            for (var j = 0; j < routeArray[i].children.length; j++) {
                let childrenPath = routeArray[i].children[j].path;
                //console.log(childrenPath);
                if (childrenPath.indexOf(category) > -1 && childrenPath.indexOf(subCategory) > -1) {
                    title = routeArray[i].children[j].title;
                    categoryName = routeArray[i].title;
                    subCategoryName = routeArray[i].children[j].title;
                    path = routeArray[i].path;
                }
            }
        } else {
            let parentPath = routeArray[i].path;
            //console.log(parentPath);
            if (parentPath.indexOf(category) > -1 && parentPath.indexOf(subCategory) > -1) {
                title = routeArray[i].title;
                categoryName = routeArray[i].title;
                subCategoryName = '';
                path = routeArray[i].path;
            }
        }
    }
    return {
        title: title,
        category: categoryName,
        subCategory: subCategoryName,
        path: path
    };
}


// WEBPACK FOOTER //
// ./src/helpers/page-front.js